var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"list-menu-item list-menu-link",class:{active: _vm.active},attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"flex-grow"},[_c('router-link',{staticClass:"flex-1 block",attrs:{"to":_vm.to}},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }